import React from 'react';
import GPSKpiTile from './GPSKpiTile';
import { safeNum } from '../../utils/gpsFormUtils';

// Per-tile definition tooltips (verbatim ticket wording) — attached to each tile.
const FORMS_TOOLTIP =
  'Nombre de formulaires distincts remplis sur la période (chaque soumission compte une fois, même si un ticket en a rempli plusieurs).';

const ANSWERS_TOOLTIP =
  'Nombre total de réponses enregistrées, toutes questions confondues (chaque réponse à chaque question est comptée).';

const STORES_TOOLTIP =
  'Nombre de magasins distincts concernés par au moins une réponse sur la période.';

const icon = (path) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={path} />
  </svg>
);

// Exactly 3 hero tiles from form-summary current/previous, using the shared
// GPSKpiTile so the comparison label matches the period type everywhere else in
// GPS_VIEWER (no more hardcoded "vs la semaine précédente"). When formsCollected
// === 0 the container renders the empty state instead of this strip.
const GPSFormHeroKPIs = ({ summary }) => {
  const current = summary && typeof summary === 'object' ? summary.current : null;
  const previous = summary && typeof summary === 'object' ? summary.previous : null;

  const cur = current && typeof current === 'object' ? current : {};
  const prev = previous && typeof previous === 'object' ? previous : {};

  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2.5">
      <GPSKpiTile
        label="Formulaires collectés"
        value={safeNum(cur.formsCollected)}
        previousValue={safeNum(prev.formsCollected)}
        icon={icon('M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z')}
        description={FORMS_TOOLTIP}
      />
      <GPSKpiTile
        label="Réponses enregistrées"
        value={safeNum(cur.answersRecorded)}
        previousValue={safeNum(prev.answersRecorded)}
        icon={icon('M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4')}
        description={ANSWERS_TOOLTIP}
      />
      <GPSKpiTile
        label="Magasins concernés"
        value={safeNum(cur.storesCovered)}
        previousValue={safeNum(prev.storesCovered)}
        icon={icon('M3 7l1.5-3h15L21 7M4 7v13a1 1 0 001 1h14a1 1 0 001-1V7M9 21V12h6v9')}
        description={STORES_TOOLTIP}
      />
    </div>
  );
};

export default GPSFormHeroKPIs;
